import React from "react";
import "./styles.scss";

export default () => (
  <div className="post post_place_holder">
    <div className="excerpt mb-4">
      <div className="d-flex align-items-center">
        <span className="profile_picture text link mr-3"></span>
        <span className="category text link"></span>
      </div>
      <div className="ml-6">
        <div className="text line"></div>
        <div className="text line"></div>
        <div className="text"></div>
      </div>
    </div>
  </div>
);
